// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavBar_navbar__2UpCW v-center"};